module.exports = __webpack_public_path__ + "img/LOGO-100.2e1bdda2.png";